import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import styles from './WhiteBoxWrapper_new.module.scss'

interface IWhiteBoxWrapper {
  children?: ReactNode
  className?: string
}

export const WhiteBoxWrapper: FC<IWhiteBoxWrapper> = ({ children, className }) => {
  return <div className={classNames(styles.container, className)}>{children}</div>
}
